import { MIN_LENGTH_FOR_NSN, MAX_LENGTH_FOR_NSN, PLUS_CHARS, VALID_DIGITS } from "./constants.js";
import ParseError from "./ParseError.js";
import Metadata, { getCountryCallingCode } from "./metadata.js";
import isViablePhoneNumber, { isViablePhoneNumberStart } from "./helpers/isViablePhoneNumber.js";
import extractExtension from "./helpers/extension/extractExtension.js";
import parseIncompletePhoneNumber from "./parseIncompletePhoneNumber.js";
import { isPossibleNumber } from "./isPossible.js";
import PhoneNumber from "./PhoneNumber.js";
import matchesEntirely from "./helpers/matchesEntirely.js";
import extractCountryCallingCode from "./helpers/extractCountryCallingCode.js";
import extractNationalNumber from "./helpers/extractNationalNumber.js";
import getCountryByCallingCode from "./helpers/getCountryByCallingCode.js";
import extractFormattedPhoneNumberFromPossibleRfc3966NumberUri from "./helpers/extractFormattedPhoneNumberFromPossibleRfc3966NumberUri.js";
var MAX_INPUT_STRING_LENGTH = 250, PHONE_NUMBER_START_PATTERN = new RegExp("[" + PLUS_CHARS + VALID_DIGITS + "]"), AFTER_PHONE_NUMBER_END_PATTERN = new RegExp("[^" + VALID_DIGITS + "#]+$");
function parse(text, options, metadata) {
  if (options = options || {}, metadata = new Metadata(metadata), options.defaultCountry && !metadata.hasCountry(options.defaultCountry))
    throw options.v2 ? new ParseError("INVALID_COUNTRY") : new Error("Unknown country: ".concat(options.defaultCountry));
  var _parseInput = parseInput(text, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error = _parseInput.error;
  if (!formattedPhoneNumber) {
    if (options.v2)
      throw error === "TOO_SHORT" ? new ParseError("TOO_SHORT") : new ParseError("NOT_A_NUMBER");
    return {};
  }
  var _parsePhoneNumber = parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource, carrierCode = _parsePhoneNumber.carrierCode;
  if (!metadata.hasSelectedNumberingPlan()) {
    if (options.v2)
      throw new ParseError("INVALID_COUNTRY");
    return {};
  }
  if (!nationalNumber || nationalNumber.length < MIN_LENGTH_FOR_NSN) {
    if (options.v2)
      throw new ParseError("TOO_SHORT");
    return {};
  }
  if (nationalNumber.length > MAX_LENGTH_FOR_NSN) {
    if (options.v2)
      throw new ParseError("TOO_LONG");
    return {};
  }
  if (options.v2) {
    var phoneNumber = new PhoneNumber(countryCallingCode, nationalNumber, metadata.metadata);
    return country && (phoneNumber.country = country), carrierCode && (phoneNumber.carrierCode = carrierCode), ext && (phoneNumber.ext = ext), phoneNumber.__countryCallingCodeSource = countryCallingCodeSource, phoneNumber;
  }
  var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) : !1;
  return options.extended ? {
    country,
    countryCallingCode,
    carrierCode,
    valid,
    possible: valid ? !0 : !!(options.extended === !0 && metadata.possibleLengths() && isPossibleNumber(nationalNumber, metadata)),
    phone: nationalNumber,
    ext
  } : valid ? result(country, nationalNumber, ext) : {};
}
function _extractFormattedPhoneNumber(text, extract, throwOnError) {
  if (text) {
    if (text.length > MAX_INPUT_STRING_LENGTH) {
      if (throwOnError)
        throw new ParseError("TOO_LONG");
      return;
    }
    if (extract === !1)
      return text;
    var startsAt = text.search(PHONE_NUMBER_START_PATTERN);
    if (!(startsAt < 0))
      return text.slice(startsAt).replace(AFTER_PHONE_NUMBER_END_PATTERN, "");
  }
}
function parseInput(text, v2, extract) {
  var number = extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(text, {
    extractFormattedPhoneNumber: function(text2) {
      return _extractFormattedPhoneNumber(text2, extract, v2);
    }
  });
  if (!number)
    return {};
  if (!isViablePhoneNumber(number))
    return isViablePhoneNumberStart(number) ? {
      error: "TOO_SHORT"
    } : {};
  var withExtensionStripped = extractExtension(number);
  return withExtensionStripped.ext ? withExtensionStripped : {
    number
  };
}
function result(country, nationalNumber, ext) {
  var result2 = {
    country,
    phone: nationalNumber
  };
  return ext && (result2.ext = ext), result2;
}
function parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
  var _extractCountryCallin = extractCountryCallingCode(parseIncompletePhoneNumber(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata), countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource, countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number, country;
  if (countryCallingCode)
    metadata.selectNumberingPlan(countryCallingCode);
  else if (number && (defaultCountry || defaultCallingCode))
    metadata.selectNumberingPlan(defaultCountry, defaultCallingCode), defaultCountry && (country = defaultCountry), countryCallingCode = defaultCallingCode || getCountryCallingCode(defaultCountry, metadata.metadata);
  else return {};
  if (!number)
    return {
      countryCallingCodeSource,
      countryCallingCode
    };
  var _extractNationalNumbe = extractNationalNumber(parseIncompletePhoneNumber(number), metadata), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode, exactCountry = getCountryByCallingCode(countryCallingCode, {
    nationalNumber,
    defaultCountry,
    metadata
  });
  return exactCountry && (country = exactCountry, exactCountry === "001" || metadata.country(country)), {
    country,
    countryCallingCode,
    countryCallingCodeSource,
    nationalNumber,
    carrierCode
  };
}
export {
  parse as default
};
//# sourceMappingURL=parse.js.map
